'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

const BusinessProblems: React.FC = () => {
	return (
		<section className={styles.businessProblems}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.subtitle}>Решаем задачи бизнеса</div>
				<h2
					className={styles.title}
					dangerouslySetInnerHTML={{ __html: '<span>С какими сложностями сталкивается бизнес</span>' }}
				/>
			</AnimatedSection>
			<div className={styles.sections}>
				<AnimatedSection animation='slideUp' className={styles.section}>
					<h3 className={styles.sectionTitle}>Проблема</h3>
					<p
						className={styles.text}
						dangerouslySetInnerHTML={{
							__html:
								'При работе с выплатами физлиц бизнес сталкивается с необходимостью <span>передавать доступ от СберБизнес</span> другим сотрудникам, добавлять пользователей и работать в сложном интерфейсе, не предназначенном для частых выплат физическим лицам.'
						}}
					/>
				</AnimatedSection>
				<AnimatedSection animation='slideUp' className={styles.section}>
					<h3 className={styles.sectionTitle}>Решение</h3>
					<p
						className={styles.text}
						dangerouslySetInnerHTML={{
							__html:
								'TrueCodePay B2C — сервис для удобных и контролируемых выплат физическим лицам с бизнес-карты, позволяющий <span>разграничить доступ и упростить процесс переводов</span>.'
						}}
					/>
				</AnimatedSection>
			</div>
		</section>
	)
}

BusinessProblems.displayName = 'BusinessProblems'

export default BusinessProblems
